import type { Preset } from "~/protocol";

/** The video presets the server templated into web/index.html's `featurette-presets` meta
 * (server/site.ts presetsJson): the composer's dropdown and the key it opens on. */
const parsed = JSON.parse(
  document.querySelector('meta[name="featurette-presets"]')?.getAttribute("content") ??
    '{"default":"","presets":[]}',
) as { default: string; presets: Preset[] };

export const presets: readonly Preset[] = parsed.presets;
export const composerDefault: Preset | undefined = presets.find((p) => p.key === parsed.default);
